import { ApprovalRequestAdditionalInfo } from '@/interfaces/approvals/approvals';
import { Person } from '@/interfaces/person';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ofuscate } from '@/utils/obfuscation';
import { noWhiteSpace } from '@/validators/noWhiteSpace';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApprovalsService } from '../../../../../../services/approvals/approvals.service';
import { Roles } from '@/auth/enum/auth.enum';
import { AuthService } from '@/auth/service/auth.service';


@Component({
  selector: 'app-request-more-info[virtualRole]',
  templateUrl: './request-more-info.component.html',
  styleUrls: [
    './request-more-info.component.css',
    '../../approve.component.css',
  ],
})
export class RequestMoreInfoComponent {
  @Input() controlForm = new FormControl(null, [Validators.required, noWhiteSpace('Write a character')]);
  @Input() selectedPersonEmail?: string;
  @Input() requirementId?: number;
  @Input() virtualRole: Roles = '';

  @Output() goBack = new EventEmitter();

  loggedPerson?: Person;

  constructor(
    private store: Store<StoreState>,
    private route: ActivatedRoute,
    private router: Router,
    private serviceApprovals: ApprovalsService,
    private auth: AuthService,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (loggedPerson) => {
        this.loggedPerson = loggedPerson;
      },
    });
  }

  onSubmit() {
    const note = this.controlForm.value.trim();
    if (note) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres solicitar más antecedentes?',
        // text: 'La solicitud será enviada  automáticamente si continúa en solicitar.',
        // text2: 'Presiona volver para regresar a la pantalla anterior',
        text: 'Si ya has revisado la información registrada y está correcta, continúa en Solicitar.',
        text2: 'De lo contrario, presiona  Volver para revisar la información.',
        acceptButtonText: 'Solicitar',
        actionOnAccept: () => {
          const params: ApprovalRequestAdditionalInfo = {
            actionType: 4,
            updaterRole: this.auth.getMyRole().id,
            requirementId: this.requirementId as number,
            updaterMdmid: this.loggedPerson?.mdmid as string,
            comment: note,
          };
          // primer dispatch
          this.store.dispatch(loaderAnimationShow());
          this.serviceApprovals.requestAdditionalInfo(params, this.virtualRole)
            .subscribe({
              next: (res) => {
                const ofuscatedData = ofuscate({ email: this.selectedPersonEmail });
                this.router.navigate(['requested-more-info', ofuscatedData], { relativeTo: this.route });
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {

                      const ofuscatedData = ofuscate({ variant: 'failure' });
                      this.router.navigate(['requested-more-info', ofuscatedData], { relativeTo: this.route });

                    }
                  },
                });


              },
              complete: () => {
                // segundo dispatch
                this.store.dispatch(loaderAnimationHide());
              },

            });

        },

      }));
    }
  }

  onGoBack() {
    this.goBack.emit('');
  }
}
